import { Avatar, Badge, Button, Col, Row, Space, Tag, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import GlobalSearch from '../CommonElements/GlobalSearch'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { BellOutlined, CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, StarOutlined, UserOutlined } from '@ant-design/icons'
import { getAuthToken, getCurrentUser } from '../../utils/authHelpers'
import ProfileCard from '../ProfileCard.js/ProfileCard'
import { setIsLoginPage } from '../../features/Auth/authSlice'
import SubscriptionSection from '../../pages/Organizations/Subscriptions/SubscriptionsSection'
import JobSeekerSubscription from '../CommonElements/JobSeekerSubscription'
import { getRemainingDaysMessage } from '../../utils/helpers'
import styles from './style.module.scss'
import NotificationsDrawer from '../CommonElements/NotificationsDrawer'
import PricingComponent from '../../pages/GuestUsers/PricingComponent'
import { get_jobseeker } from '../../features/UserInfo/userInfoSlice'
import { get_organization } from '../../features/Organization/OrgAuth/OrgAuthSlice'

const HeaderRightSection = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userProfile, notifications, notificationCount } = useSelector((state) => state.global);
    const [subscription, setSubscription] = useState(userProfile?.subscription);
    const loggedInToken = getAuthToken();
    let currentUser = getCurrentUser();
    const [issubscription, setIsSubscription] = useState(false)
    const [issubscriptionJob, setIsSubscriptionJob] = useState(false);
    const { latestSubscriptionsorg } = useSelector((state) => state.organizationData);
    const { latestSubscriptions } = useSelector((state) => state.userData);
    const [openOrgNotifications, setOpenOrgNotifications] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getSubscriptionStyle = (type) => {
        switch (type) {
            case 'premium':
                return {
                    backgroundColor: '#fffbe6',
                    borderColor: '#faad14',
                    color: '#d48806',
                    icon: <StarOutlined />,
                };
            case 'standard':
                return {
                    backgroundColor: '#e6f7ff',
                    borderColor: '#1890ff',
                    color: '#096dd9',
                    icon: <UserOutlined />,
                };
            case 'free':
            default:
                return {
                    backgroundColor: '#f9f0ff',
                    borderColor: '#9254de',
                    color: '#722ed1',
                    icon: <ClockCircleOutlined />,
                };
        }
    };

    const subscriptionType = latestSubscriptionsorg?.type || 'free';
    const subscriptionStyle = getSubscriptionStyle(subscriptionType);

    const getSubscriptionStyleByRemainingDays = (expirationDateTime) => {
        const expiration = new Date(expirationDateTime);
        const today = new Date();
        const diffInDays = Math.ceil((expiration - today) / (1000 * 60 * 60 * 24));

        if (diffInDays > 10) {
            return {
                backgroundColor: '#f6ffed',
                borderColor: '#52c41a',
                color: '#389e0d',
                icon: <CheckCircleOutlined />,
            };
        } else if (diffInDays <= 3) {
            return {
                backgroundColor: '#fff2f0',
                borderColor: '#ff4d4f',
                color: '#cf1322',
                icon: <ExclamationCircleOutlined />,
            };
        } else {
            return {
                backgroundColor: '#fffbe6',
                borderColor: '#faad14',
                color: '#d48806',
                icon: <ClockCircleOutlined />,
            };
        }
    };

    const goToLoginPage = () => navigate('/login');

    const goToSignUpPage = () => {
        dispatch(setIsLoginPage(false));
        navigate('/sign-up');
    };

    useEffect(() => {
        if (loggedInToken) {
            if (currentUser === "organization") {
                dispatch(get_organization(navigate))
            }else{
                dispatch(get_jobseeker(navigate))
            }
        }
    }, [])

    return (
        <div style={{ padding: '0 0px' }}>
            {loggedInToken ?
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                    }}
                >
                    <div className='add-cursor' onClick={() => setOpenOrgNotifications(true)}>
                        <Badge count={notificationCount}><div><Avatar size={30}
                            className='blueGradiant' icon={<BellOutlined />} /></div></Badge></div>
                    {currentUser !== 'organization' && <div style={{ flex: '1 1 80px' }}>
                        <GlobalSearch />

                    </div>}
                    {
                        windowWidth >= 495 && <>{loggedInToken &&
                            <div>

                                <div style={windowWidth <= 832 ? { flex: '1 1 50px' } : { flex: '1 1 200px' }}>

                                    {currentUser === "organization" ?
                                        <div>
                                            <>
                                                <Row align="middle" justify="space-between" gutter={[16, 16]}>
                                                    {latestSubscriptionsorg?.name ? (
                                                        <Col>
                                                            <Tooltip title={`Remaining Posts: ${userProfile?.remainingJDPlans}`}>
                                                                <Button
                                                                    type="default"
                                                                    size='small'
                                                                    onClick={() => {
                                                                        setIsSubscription(true);
                                                                    }}
                                                                    style={{
                                                                        ...getSubscriptionStyleByRemainingDays(latestSubscriptionsorg?.expirationDateTime),
                                                                        fontWeight: 600,
                                                                        padding: windowWidth <= 344 ? '15px 1px' : '15px 20px',
                                                                        borderRadius: '25px',
                                                                        boxShadow: '0 3px 10px rgba(0, 0, 0, 0.15)',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '8px',
                                                                    }}
                                                                >
                                                                    {windowWidth >= 500 && subscriptionStyle.icon}
                                                                    <span className='text-uppercase'>
                                                                        {latestSubscriptionsorg?.type} <span style={windowWidth <= 832 ? { display: 'none' } : {}}>
                                                                            | {" "}
                                                                            {getRemainingDaysMessage(latestSubscriptionsorg?.expirationDateTime)}
                                                                        </span>
                                                                    </span>
                                                                </Button>
                                                            </Tooltip>
                                                        </Col>
                                                    ) :

                                                        <Col>
                                                            <Button
                                                                type="primary"
                                                                shape='round'
                                                                onClick={() => setIsSubscription(true)}
                                                                className='blueGradiant'
                                                            >
                                                                Activate Subscription Plan
                                                            </Button>
                                                        </Col>
                                                    }
                                                </Row>
                                            </>

                                        </div> :
                                        <div>
                                            {latestSubscriptions?.name ? (
                                                <Button
                                                    type="default"
                                                    size='small'
                                                    onClick={() => setIsSubscriptionJob(true)}
                                                    style={{
                                                        ...getSubscriptionStyleByRemainingDays(latestSubscriptions?.expirationDateTime),
                                                        fontWeight: 600,
                                                        padding: windowWidth <= 344 ? '15px 1px' : '15px 20px',
                                                        borderRadius: '25px',
                                                        boxShadow: '0 3px 10px rgba(0, 0, 0, 0.15)',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                    }}
                                                >
                                                    {windowWidth >= 500 && subscriptionStyle.icon}
                                                    <span className='text-uppercase'>
                                                        {latestSubscriptions?.type}
                                                        <span
                                                            style={windowWidth <= 832 ? { display: 'none' }
                                                                : {}}
                                                        > | {' '}
                                                            {getRemainingDaysMessage(latestSubscriptions?.expirationDateTime)} </span>
                                                    </span>
                                                </Button>
                                            ) : (
                                                <Button
                                                    type="primary"
                                                    onClick={() => setIsSubscriptionJob(true)}
                                                    shape='round'
                                                    className='blueGradiant'
                                                >
                                                    Activate Subscription Plan
                                                </Button>
                                            )}
                                        </div>
                                    }
                                </div>
                            </div>
                        }</>
                    }

                    <div style={{ flex: '1 1 0px' }}>
                        {loggedInToken ? (

                            <Tag className={styles.profileCardWrapper}>
                                <ProfileCard />
                            </Tag>

                        ) : (
                            <Row gutter={[16, 16]} style={{ padding: '5px' }}>
                                <Col xs={12} lg={12} md={12} >
                                    <Button shape="round" size="large" className="active-border" onClick={goToLoginPage} type="text">
                                        Log in
                                    </Button>
                                </Col>
                                <Col xs={12} lg={12} md={12}>
                                    <Button shape="round" size="large" className="default-button-style" onClick={goToSignUpPage} type="primary">
                                        Sign up
                                    </Button>
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>
                :
                <Space>
                    {currentUser !== 'organization' && <div style={{ flex: '1 1 80px' }}>
                        <GlobalSearch />

                    </div>}
                    <>
                        <Button shape="round" size="large" className="active-border" onClick={goToLoginPage} type="text">
                            Log in
                        </Button>
                        <Button shape="round" size="large" className="default-button-style" onClick={goToSignUpPage} type="primary">
                            Sign up
                        </Button>
                    </>

                </Space>

            }
            {/* <SubscriptionSection subscription={subscription} issubscription={issubscription} setIsSubscription={setIsSubscription}
                setSubscription={setSubscription} />
            <PricingComponent visible={issubscriptionJob} onClose={() => setIsSubscriptionJob(false)} /> */}
            <PricingComponent
                visible={
                    currentUser === 'organization'
                        ? issubscription
                        : issubscriptionJob

                }
                onClose={() => {
                    if (currentUser === 'organization') return setIsSubscription(false);
                    return setIsSubscriptionJob(false);
                }}
            />
            <NotificationsDrawer
                open={openOrgNotifications}
                onClose={() => setOpenOrgNotifications(false)}
            />

        </div>
    );
};

export default HeaderRightSection;
